var render = function render(){var _vm=this,_c=_vm._self._c;return _c('awesome-table',{attrs:{"labels":_vm.labels,"items":_vm.products,"options":{
        sort: false,
        addButton: false,
        pagination: false,
        searchInput: false,
        filters: false,
        link: false,
        isCard: false
    }},on:{"row-click":_vm.onRowClick},scopedSlots:_vm._u([{key:`items.attributes`,fn:function({ item }){return [(item.attributes.length)?_c('div',_vm._l((item.attributes),function(attribute,index){return _c('div',{key:index},[_c('span',[_vm._v(" "+_vm._s(attribute.group.name)+": "+_vm._s(attribute.value)+" ")])])}),0):_c('div',[_vm._v(" - ")])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }